AppTabs.createTab( {
name: 'test-management',
icon: 'vial',
text: 'Test Management',
create: function(init) {
	'use strict'

	const tab = this;
	init.setDataTableArgs( {

		tableId: 		'#data-table-test-management',

		readTableName: 	'tblTestList',
		editTableName: 	'tblTestList',
		primaryKey: 	'TestID',

		drawWhen:           false,
		hasColumnFilters: 	true,
		canSearch: 			true,
		canSort:			true,

		actionData:			'datatable',
		actionCreate:		'datatable_create',
		actionEdit:			'datatable_edit',
		actionRemove:		'datatable_remove',

		editCallback:		function() {
			window.broadcastLocalStorageUpdateRequest( 'testList' );
		},

		fields: [
			{
				label: 'Test Name',
				columnName: 'TestName',
				isEditable: true,
			},
			{
				label: 'Test Display Name',
				columnName: 'TestDisplayName',
				isEditable: true,
			},
			{
				label: 'Method',
				columnName: 'Method',
				isEditable: true,
			},
			{
				label: 'Preferred Units',
				columnName: 'PreferredUnits',
				type: 'combobox',
				datalist: 'units',
				isEditable: true,
			},
			{
				label: 		'LOD / LOQ Ratio',
				columnName: 'LOD_LOQRatio',
				isEditable: true,
			},
			{
				label: 		'LOD',
				columnName: 'LOD',
				isEditable: true,
			},
			{
				label: 		'LOQ',
				columnName: 'LOQ',
				isEditable: true,
			},
			{
				label: 'Test Group',
				columnName: 'TestGroup',
				isEditable: true,
			},
			{
				label: 'Test Subgroup',
				columnName: 'TestSubgroup',
				isEditable: true,
			},
			{
				label: 'Metals',
				columnName: 'Metals',
				isEditable: true,
				type: 'boolean',
			},
			{
				label: 'Metals Log Print',
				columnName: 'MetalsLogPrint',
				isEditable: true,
				type: 'boolean',
			},
		],

	} );

	let loaded = false;
	init.setController( {
		onOpenTab() {
			if ( loaded ) {
				tab.drawTable();
				return;
			}
			window.LocalStorageManager.loadField( 'dnrTestList' ).then( tab.drawTable );
			loaded = true;
		},
	} );
}

} );
